import { BaseDto } from './base-dto';

export class Login extends BaseDto {
    public UserName!: string;
    public Pwd!: string;
    public Success!: boolean;
    public chg_pwd!: boolean;
}
